import { createContext } from 'react';

import { CDFICertificationContextType } from '@/types';

export const CDFICertificationContext = createContext({} as CDFICertificationContextType);
